module.exports = __webpack_public_path__ + "1ef97b95e3c0b32bc761d1c36f8150d6.pdf";